import Service from "./Service"

class FilterService extends Service {

    search = (queryParams) => this.getWithParams("/filters", queryParams)

    create = (requestBody) => this.post("/filters", requestBody)

    update = (id, requestBody) => this.patch(`/filters/${id}`, requestBody)

    delete = (id) => this.del(`/filters/${id}`)
}

const filterService = new FilterService()
export default filterService